<img [src]="content.src" [alt]="content.alt" class="idp-image img-fluid" />
